import { LogoContainer } from 'reservations/payments/components/LogoContainer';

export function DiscoverLogo() {
  return (
    <LogoContainer>
      <svg
        data-testid="discover-logo"
        width="32"
        height="20"
        viewBox="0 0 32 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.3102 18.2848H31.2849V18.7848C31.2849 19.0909 31.0278 19.3481 30.7216 19.3481H1.10138C0.795242 19.3481 0.538086 19.0909 0.538086 18.7848V1.06329C0.538086 0.757155 0.795241 0.5 1.10138 0.5H30.747C31.0531 0.5 31.3102 0.757154 31.3102 1.06329V18.2848Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M8.77246 19.8481H30.7472C31.3294 19.8481 31.8104 19.3671 31.8104 18.7848V11.3671C29.6839 12.6835 21.7345 17.2911 8.77246 19.8481Z"
          fill="#F58220"
        />
        <path
          d="M16.2912 8.37976C15.4051 8.37976 14.6963 9.06331 14.6963 9.89875C14.6963 10.7848 15.3798 11.4684 16.2912 11.4684C17.1773 11.4684 17.8608 10.7848 17.8608 9.92407C17.8862 9.06331 17.2026 8.37976 16.2912 8.37976Z"
          fill="url(#paint0_radial)"
        />
        <path
          d="M7.30412 8.43085H6.44336V11.3929H7.2788C7.7345 11.3929 8.06361 11.2916 8.3421 11.0384C8.67121 10.76 8.87374 10.3296 8.87374 9.8992C8.89906 9.03844 8.24083 8.43085 7.30412 8.43085ZM7.98767 10.6587C7.81045 10.8359 7.55728 10.8865 7.20285 10.8865H7.05096V8.91186H7.20285C7.5826 8.91186 7.81045 8.98781 7.98767 9.13971C8.1902 9.31692 8.31678 9.5954 8.31678 9.87389C8.31678 10.203 8.1902 10.4815 7.98767 10.6587Z"
          fill="#001722"
        />
        <path
          d="M9.76001 8.43036H9.17773V11.3924H9.76001V8.43036Z"
          fill="#001722"
        />
        <path
          d="M11.178 9.56962C10.8236 9.44304 10.7223 9.36709 10.7223 9.18987C10.7223 9.01266 10.8995 8.86076 11.1527 8.86076C11.3299 8.86076 11.4565 8.93671 11.6084 9.08861L11.9122 8.68354C11.659 8.4557 11.3552 8.35443 11.0261 8.35443C10.4945 8.35443 10.0894 8.70886 10.0894 9.21519C10.0894 9.62025 10.2666 9.82278 10.8236 10.0253C11.0514 10.1013 11.178 10.1519 11.2286 10.2025C11.3552 10.2785 11.4059 10.3797 11.4059 10.5063C11.4059 10.7595 11.2033 10.9367 10.9502 10.9367C10.6717 10.9367 10.4438 10.8101 10.3172 10.5316L9.9375 10.8861C10.216 11.2658 10.5198 11.443 10.9755 11.443C11.5831 11.443 11.9881 11.038 11.9881 10.4557C12.0134 10.0253 11.8362 9.82278 11.178 9.56962Z"
          fill="#001722"
        />
        <path
          d="M12.2158 9.92405C12.2158 10.8101 12.8994 11.4684 13.7854 11.4684C14.0386 11.4684 14.2411 11.4177 14.5196 11.2911V10.6076C14.2918 10.8354 14.0892 10.9367 13.8108 10.9367C13.2285 10.9367 12.8234 10.5063 12.8234 9.92405C12.8234 9.34177 13.2538 8.91139 13.7854 8.91139C14.0639 8.91139 14.2665 9.01266 14.5196 9.24051V8.55696C14.2665 8.43038 14.0639 8.37975 13.8108 8.37975C12.8994 8.35443 12.2158 9.06329 12.2158 9.92405Z"
          fill="#001722"
        />
        <path
          d="M19.2028 10.4304L18.3927 8.43036H17.7598L19.0256 11.4683H19.3547L20.6205 8.43036H19.9876L19.2028 10.4304Z"
          fill="#001722"
        />
        <path
          d="M20.8994 11.3924H22.545V10.9114H21.4564V10.1012H22.4944V9.59492H21.4564V8.93669H22.545V8.43036H20.8994V11.3924Z"
          fill="#001722"
        />
        <path
          d="M24.8235 9.31643C24.8235 8.75947 24.4437 8.43036 23.7602 8.43036H22.8994V11.3924H23.4817V10.2025H23.583L24.3931 11.3924H25.1019L24.1652 10.1519C24.5956 10.0759 24.8235 9.77213 24.8235 9.31643ZM23.6589 9.79745H23.4817V8.88605H23.6589C24.0133 8.88605 24.2159 9.03795 24.2159 9.31643C24.2412 9.64555 24.0387 9.79745 23.6589 9.79745Z"
          fill="#001722"
        />
        <path
          d="M25.228 8.65822C25.228 8.60759 25.2027 8.58228 25.1267 8.58228H25.0508V8.83544H25.1014V8.73417L25.1774 8.83544H25.2533L25.1774 8.73417C25.228 8.70886 25.228 8.68354 25.228 8.65822ZM25.1267 8.68354V8.60759C25.152 8.60759 25.1774 8.60759 25.1774 8.63291C25.1774 8.68354 25.152 8.68354 25.1267 8.68354Z"
          fill="#231F20"
        />
        <path
          d="M25.1527 8.48102C25.0261 8.48102 24.9248 8.58228 24.9248 8.70887C24.9248 8.83545 25.0261 8.93671 25.1527 8.93671C25.2792 8.93671 25.3805 8.83545 25.3805 8.70887C25.3805 8.58228 25.2792 8.48102 25.1527 8.48102ZM25.1527 8.88608C25.0514 8.88608 24.9754 8.81013 24.9754 8.70887C24.9754 8.6076 25.0514 8.53165 25.1527 8.53165C25.2539 8.53165 25.3299 8.6076 25.3299 8.70887C25.3299 8.81013 25.2539 8.88608 25.1527 8.88608Z"
          fill="#231F20"
        />
        <defs>
          <radialGradient
            id="paint0_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(16.3011 9.9246) scale(1.56481)"
          >
            <stop offset="0.005618" stop-color="#FFEEE0" />
            <stop offset="0.1096" stop-color="#FEE9D7" />
            <stop offset="0.2793" stop-color="#FDDBBF" />
            <stop offset="0.4935" stop-color="#FBC597" />
            <stop offset="0.744" stop-color="#F8A560" />
            <stop offset="1" stop-color="#F48120" />
          </radialGradient>
        </defs>
      </svg>
    </LogoContainer>
  );
}
